export const parameterList = [
  "packaging_140ml_fill_weight_g",
  "packaging_140ml_removal_torque_ncm",
  "packaging_140ml_density_g_per_ml",
];

export const plotTypeOptions = [
  { label: "Control Chart", value: "control_chart" },
  { label: "Process Capability", value: "process_capability" },
  // { label: "QQ Chart", value: "qq_chart" },
  { label: "X-Bar", value: "xbar_chart" },
  { label: "PP Chart", value: "pp_chart" },
];
// export const sitesList = [
//   { id: "1", name: "Site A_1" },
//   { id: "2", name: "Site A_2" },
//   { id: "3", name: "Site A_3" },
//   { id: "4", name: "Site B_1" },
//   { id: "5", name: "Site B_2" },
// ];

// export const productList = [{ id: "1", name: "Chloroform" }];

// export const unitOfOperationList = [{ id: "1", name: "uoop" }];

export const ruleOptions = [
  {
    key: "rule1",
    label: "Rule 1",
    description: "1 point above/below the control limits",
  },
  {
    key: "rule2",
    label: "Rule 2",
    description: "9 points in a row on same side of centerline",
  },
  {
    key: "rule3",
    label: "Rule 3",
    description: "6 point in a row increasing or decreasing",
  },
  {
    key: "rule4",
    label: "Rule 4",
    description: "14 points in a row alternating up and down",
  },
  {
    key: "rule5",
    label: "Rule 5",
    description: "2 of 3 points in a row above/below the warning limits",
  },
];

export const yourBatchArray = [
  { batchId: "BATCH001", date: "2024-08-01" },
  { batchId: "BATCH002", date: "2024-08-02" },
  { batchId: "BATCH003", date: "2024-08-03" },
  { batchId: "BATCH004", date: "2024-08-04" },
  { batchId: "BATCH005", date: "2024-08-05" },
  { batchId: "BATCH006", date: "2024-08-06" },
  { batchId: "BATCH007", date: "2024-08-07" },
  { batchId: "BATCH008", date: "2024-08-08" },
  { batchId: "BATCH009", date: "2024-08-09" },
  { batchId: "BATCH010", date: "2024-08-10" },
  { batchId: "BATCH011", date: "2024-08-11" },
  { batchId: "BATCH012", date: "2024-08-12" },
  { batchId: "BATCH013", date: "2024-08-13" },
  { batchId: "BATCH014", date: "2024-08-14" },
  { batchId: "BATCH015", date: "2024-08-15" },
  { batchId: "BATCH016", date: "2024-08-16" },
  { batchId: "BATCH017", date: "2024-08-17" },
  { batchId: "BATCH018", date: "2024-08-18" },
  { batchId: "BATCH019", date: "2024-08-19" },
  { batchId: "BATCH020", date: "2024-08-20" },
  { batchId: "BATCH021", date: "2024-08-21" },
  { batchId: "BATCH022", date: "2024-08-22" },
  { batchId: "BATCH023", date: "2024-08-23" },
  { batchId: "BATCH024", date: "2024-08-24" },
  { batchId: "BATCH025", date: "2024-08-25" },
  { batchId: "BATCH026", date: "2024-08-26" },
  { batchId: "BATCH027", date: "2024-08-27" },
  { batchId: "BATCH028", date: "2024-08-28" },
  { batchId: "BATCH029", date: "2024-08-29" },
  { batchId: "BATCH030", date: "2024-08-30" },
];

export const limitTypeOptions = [
  "User Preset",
  "User Defined",
  "Sample Calculation",
];

export const specLimitTypeOptions = ["User Preset", "User Defined"];
export const targetLimitTypeOptions = ["User Preset", "User Defined"];

// export const rulesetOptions = [{ label: "Nelson", value: "nelson" }];

export const distributionCurvesOptions = [
  { label: "Normal", value: "norm" },
  { label: "Log", value: "lnorm" },
  { label: "Gamma", value: "gamma" },
  { label: "Weibull", value: "weibull" },
  { label: "Exponential", value: "exp" },
  { label: "Logistic", value: "logis" },
  { label: "Cauchy", value: "cauchy" },
  { label: "Geometric (for discrete data)", value: "geom" },
  // { label: "Negative Binomial (discrete)", value: "nbinom" },
  // { label: "Poisson (discrete)", value: "pois" },
  // { label: "Beta (0–1 bounded)", value: "beta" },
  // { label: "Uniform", value: "unif" },
  // { label: "Johnson Sb", value: "johnsonsb" },
  { label: "Box Cox", value: "Box Cox" },
  { label: "Johnson Sb", value: "Johnson" },
];

export const transformationOptions = [
  { label: "None", value: "none" },

  // { label: "Log transformation", value: "log" },
  // { label: "Box-Cox transformation", value: "boxcox" },
  // { label: "Yeo-Johnson transformation", value: "yeojohnson" },
  { label: "Box Cox", value: "Box Cox" },
  // { label: "Reciprocal transformation", value: "reciprocal" },
  // { label: "Logit transformation", value: "logit" },
  // { label: "Arcsine transformation", value: "arcsine" },
  // { label: "Rank Transformed", value: "rank" },
  { label: "Johnson Sb", value: "Johnson" },
];
export const staticTable = [
  {
    Distribution: "Weibull",
    AIC: -14610.78,
    BIC: -14599.58,
    LogLik: 7307.39,
    KS_p_value: 0,
    AD_p_value: 3e-7,
    Is_Best_Fit: true,
  },
  {
    Distribution: "Gamma",
    AIC: -12684.96,
    BIC: -12673.76,
    LogLik: 6344.48,
    KS_p_value: 0,
    AD_p_value: 3e-7,
    Is_Best_Fit: false,
  },
];

export const initialFolders = [
  {
    id: 1,
    name: "Documents",
    children: [
      {
        id: 2,
        name: "Reports",
        children: [
          { id: 3, name: "2024", children: [] },
          { id: 4, name: "2025", children: [] },
        ],
      },
    ],
  },
  {
    id: 5,
    name: "Pictures",
    children: [],
  },
];
